import * as conversations from '@cascade/react/conversations';
import type { TConversationsProviderProps } from './Conversations.types.ts';
import { usePathSegment } from '#hooks/use-path-segment/index.ts';
import { useUserClient } from '#hooks/use-user-client/index.ts';

export const ConversationsProvider = ({
  conversationPath,
  homePath = '/',
  ...props
}: TConversationsProviderProps) => {
  const { userClient, userAgent } = useUserClient();
  const { value: conversationId, setValue: setConversationId } = usePathSegment(
    { path: conversationPath, fallbackPath: homePath },
  );

  return (
    <conversations.ConversationsProvider
      {...props}
      userClient={userClient}
      userAgent={userAgent}
      conversationId={conversationId}
      onConversationIdChange={setConversationId}
    />
  );
};
